import { useCallback } from 'react';
import * as React from 'react';
import { InputAdornment } from '@mui/material';
import YouTube from '@mui/icons-material/YouTube';
import { makeStyles } from 'tss-react/mui';
import ValidatedYoutubeInput from '../atoms/ValidatedYoutubeInput';

const useStyles = makeStyles()(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  youtubeIcon: {
    color: 'red',
  },

  inputField: {
    flexBasis: '25rem',
    flexShrink: 1,
  },
}));

export interface YoutubeInputFieldProps {
  onConfirm: (youtubeUrl: string) => void;
}

const YoutubeInputField: React.FC<YoutubeInputFieldProps> = ({ onConfirm }) => {
  const { classes } = useStyles();

  const handleOnChange = useCallback((url: string, valid: boolean) => {
    console.log('InputField: OnCHange: ', url, valid);
    if (valid) {
      // immediately confirm when valid url is pasted
      onConfirm(url);
    }
  }, [onConfirm]);

  return (
    <div className={classes.container}>
      <div className={classes.inputField}>
        <ValidatedYoutubeInput
          onChange={handleOnChange}
          onConfirm={onConfirm}
          startAdornment={(
            <InputAdornment position="start">
              <YouTube className={classes.youtubeIcon} />
            </InputAdornment>
          )}
        />
      </div>
    </div>
  );
};

export default YoutubeInputField;
